import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { SimpleLoader } from '@dev/ee-components';
import { Router as RouterProvider } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider as ReduxProvider } from 'react-redux';
import { boot } from '@shared-store/shared-store';

import rootSaga from '@/sagas';
import { ApplicationState, reducers } from '@/store';

import App from './App';
import { Styles } from './services/Styles';

import i18n from '../i18n';
const loader = {
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
const Loader = (): JSX.Element => (
    <div style={loader}>
        <SimpleLoader />
    </div>
);
/**
 * Unmount React App when left
 * @event leaveReactApp - declared and dispatched in file ee.js
 */

function leaveReactHandler(): void {
    const root = document.getElementById('app-root');
    if (root?.hasChildNodes()) {
        ReactDOM?.unmountComponentAtNode(document.getElementById('app-root'));
    }
    window.removeEventListener('leaveReactApp', leaveReactHandler);
}
window.addEventListener('leaveReactApp', leaveReactHandler);
const { store, history: reduxHistory } = boot<ApplicationState>({ isStandAlone: false, rootSaga, reducers });

ReactDOM.render(
    <ReduxProvider store={store}>
        <I18nextProvider i18n={i18n}>
            <RouterProvider history={reduxHistory}>
                <React.Suspense fallback={<Loader />}>
                    <Styles>
                        <App />
                    </Styles>
                </React.Suspense>
            </RouterProvider>
        </I18nextProvider>
    </ReduxProvider>,
    document.getElementById('app-root')
);

export default {};
